<div modal-body>
    <div class="dlgu-content dlgu-flex-start">
        <div class="dlgu-block1">
            <img [src]="isDarkMode ? '../../../assets/icons/question-mark-white.svg' : '../../../assets/icons/question-mark.svg'"  
                class="dlgu-icon" />
        </div>
        <div class="dlgu-block2">
            <div class="dlgu-txt">
                <label>  {{(teamName)}} {{MESSAGE_TEXT.REQUIRE_ADD_STAFF_TO_GROUP}}</label></div>
        </div>
    </div>
</div>
<div modal-bottom class="dlgu-content">
    <div class="dlgu-div-btn">
        <pivot-text-button class="dlgu-btn" (btnClick)="onSubmit(saveType.SAVE)" [buttonType]="buttonType.SECONDARY"
            [buttonText]="BUTTON.YES">
        </pivot-text-button>
        <pivot-text-button class="dlgu-btn" (btnClick)="onSubmit(saveType.CANCEL)" [buttonType]="buttonType.SECONDARY"
        [buttonText]="BUTTON.NO">
    </pivot-text-button>
    </div>
</div>

